export const mapDegree = degree => {
  switch (degree) {
    case 'S':
    case 'T':
      return 'Não escolares'
    case 'F':
      return 'Professor'
    case 'EI':
      return 'Educação Infantil'
    case 'M':
    case 'EM':
      return 'Ensino Médio'
    case '1M':
      return 'Ensino Médio 1'
    case '2M':
      return 'Ensino Médio 2'
    case '3M':
      return 'Ensino Médio 3'
    case 'E':
      return 'EJA'
    case 'Todos':
    case 'G':
      return 'Todos'
    case 'EFAI':
      return 'EFAI'
    case 'EFAF':
      return 'EFAF'
    case 'EF1':
      return 'EF1'
    case 'EF2':
      return 'EF2'
    case '1ano-fundamental':
      return '1º ano'
    case '2ano-fundamental':
      return '2º ano'
    case '3ano-fundamental':
      return '3º ano'
    case '4ano-fundamental':
      return '4º ano'
    case '5ano-fundamental':
      return '5º ano'
    case '6ano-fundamental':
      return '6º ano'
    case '7ano-fundamental':
      return '7º ano'
    case '8ano-fundamental':
      return '8º ano'
    case '9ano-fundamental':
      return '9º ano'
    default:
      return `${degree}º ano`
  }
}

export const activityCardMapDegree = degree => {
  switch (degree) {
    case 'EI':
      return 'EI'
    case 'M':
    case 'EM':
      return 'EM'
    case '1M':
      return 'EM 1'
    case '2M':
      return 'EM 2'
    case '3M':
      return 'EM 3'
    case 'E':
      return 'EJA'
    case 'G':
      return 'Todos'
    case '1ano-fundamental':
    case '2ano-fundamental':
    case '3ano-fundamental':
    case '4ano-fundamental':
    case '5ano-fundamental':
    case '6ano-fundamental':
    case '7ano-fundamental':
    case '8ano-fundamental':
    case '9ano-fundamental':
    case '1° ano':
    case '2° ano':
    case '3° ano':
    case '4° ano':
    case '5° ano':
    case '6° ano':
    case '7° ano':
    case '8° ano':
    case '9° ano': {
      const year = degree.charAt(0)
      return `${year}º ano`
    }
    case '1ano-medio':
      return '1º EM'
    case '2ano-medio':
      return '2º EM'
    case '3ano-medio':
      return '3º EM'
    default:
      return `${degree}º`
  }
}

export const trialRegisterDegree = degree => {
  switch (degree) {
    case 'EI':
      return 'Infantil'
    case 'M':
      return 'E. Médio'
    case '1M':
      return 'E. Médio 1'
    case '2M':
      return 'E. Médio 2'
    case '3M':
      return 'E. Médio 3'
    case 'E':
      return 'EJA'
    case 'G':
      return 'Todos'
    default:
      return `${degree}º ano`
  }
}

export const mapByGroupOfDegree = degree => {
  switch (degree) {
    case 'S':
    case 'T':
      return 'EM+'
    case 'F':
      return 'Prof.'
    case 'M':
    case '1M':
    case '2M':
    case '3M':
      return 'EM'
    case '6':
    case '7':
    case '8':
    case '9':
      return 'EF2'
    case '1':
    case '2':
    case '3':
    case '4':
    case '5':
      return 'EF1'
    case 'EI':
      return 'EI'
    case 'G':
      return 'Todos'
    default:
      return null
  }
}

export const mapGroupDegreeByBadge = degree => {
  switch (degree) {
    case 'EM+':
      return 'Não escolares'
    case 'Prof.':
      return 'Técnicos, teóricos e profissionalizantes'
    case 'EM':
      return 'Ensino Médio'
    case '1M':
      return 'Ensino Médio 1'
    case '2M':
      return 'Ensino Médio 2'
    case '3M':
      return 'Ensino Médio 3'
    case 'EF2':
      return 'Ensino Fundamental 2'
    case 'EF1':
      return 'Ensino Fundamental 1'
    case 'EI':
      return 'Ensino Infantil'
    case 'Todos':
      return 'Todos'
    default:
      return null
  }
}

export default mapDegree
